'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import styles from './styles.module.scss';
import { SecHero } from './sections/SecHero';
const SecFeatureIntro = dynamic(() => import('./sections/SecFeatureIntro').then(m => m.SecFeatureIntro));
const SecAiExperience = dynamic(() => import('./sections/SecAiExperience').then(m => m.SecAiExperience));
const SecSamplePreview = dynamic(() => import('./sections/SecSamplePreview').then(m => m.SecSamplePreview));
const SecFeatureDetailTabs = dynamic(() => import('./sections/SecFeatureDetailTabs').then(m => m.SecFeatureDetailTabs));
const SecPlatformPortfolio = dynamic(() => import('./sections/SecPlatformPortfolio').then(m => m.SecPlatformPortfolio));
const SecFaq = dynamic(() => import('@/widgets/public-faq').then(m => m.SecFaq));
export function IntroPageContent() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><main data-public-page="true" className={styles.introRoot}><div data-nosnippet="" className={styles.snippetGuard}><SecHero /><SecFeatureIntro /><SecAiExperience /><SecSamplePreview /><SecFeatureDetailTabs /><SecPlatformPortfolio /><SecFaq /></div></main></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}